import { Fragment } from 'react';
import { useTranslation } from 'react-i18next';

import { useAppShell } from '@/data/context/AppShellContext';

export default function ShellGreeting() {
  const { user } = useAppShell();
  const { t } = useTranslation('translation', {
    keyPrefix: 'studentDashboard.header',
  });

  return (
    <Fragment>
      {t('hello')} <span className="text-primary">{user.firstName}</span>
    </Fragment>
  );
}
